import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const AutoLogout = ({ children }) => {
    const navigate = useNavigate();
    const timerRef = useRef(null);

    // Auto logout after 15 minutes (900000 ms)
    const logoutTime = 90 * 60 * 1000;

    const logout = () => {
        sessionStorage.clear();
        navigate("/login");
        window.location.reload();
    };

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(logout, logoutTime);
    };

    useEffect(() => {

        const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer();

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    return <>{children}</>;
};

export default AutoLogout;
